import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseApi";

export const postalApi = createApi({
  reducerPath: "postalApi",
  baseQuery: (args, api) => baseQuery(args, api, { service: "postal" }),
  endpoints: () => ({}),
  tagTypes: ["configurations", "emails", "trails"],
});
